import { GlobalState } from "little-state-machine";

export const updateUserHistoryFilterDates = (state: GlobalState, userHistoryFilterDates: string[]) => ({
  ...state,
  userHistoryFilterDates
});
